import { useEffect } from "react";
import {
  BTCToFiatAmount,
  ethereumLabel,
  fetchPrecisedInteger,
  getAccountFees,
  getExchangeRate,
  lightningLabel,
  onChainLabel,
  solanaLabel,
  tronLabel,
  tonLabel,
  showAmount,
} from "../components/constants";
import { btc, sats, speed } from "../components/messages";

function useExchangeAndSpeedFeeHook({
  amount,
  currency,
  targetedCurrency,
  checkExchange,
  showBtcAmount,
  lightningWithLn,
  isOnchainMethod,
  isEthereumMethod,
  isTronMethod,
  isSolanaMethod,
  isTonMethod,
  isLnUrlMethodReceive,
  setSpeedFee,
  setFixedFee,
  setButtonLoader,
  setExchangeRate,
  setConvertedAmount,
}) {
  const getSpeedFee = async () => {
    try {
      let method;
      if (lightningWithLn) {
        method = lightningLabel;
      } else if (isOnchainMethod) {
        method = onChainLabel;
      } else if (isEthereumMethod) {
        method = ethereumLabel;
      } else if (isTronMethod) {
        method = tronLabel;
      } else if (isSolanaMethod) {
        method = solanaLabel;
      } else if (isTonMethod) {
        method = tonLabel;
      }

      if (!method) return;

      const code = isLnUrlMethodReceive ? "01" : "04";
      const speedFee = await getAccountFees(method, currency, code);
      setSpeedFee?.(speedFee.feePercentage);
      let fixedFee = Number(
        showAmount({
          amount: speedFee?.fixedFee,
          currency: currency,
          targetedCurrency: showBtcAmount && currency === sats ? btc : currency,
        })
      );

      setFixedFee(fixedFee);
    } catch (err) {
      console.error("Error fetching speed fee:", err);
    }
  };

  useEffect(() => {
    setButtonLoader?.(true);
    getExchangeRate(targetedCurrency, currency)
      .then((res) => {
        setExchangeRate?.(res?.target_lowest_rate);
        if (!checkExchange) {
          let tempConvertedAmount = fetchPrecisedInteger(
            amount / res?.target_lowest_rate,
            2
          );
          if (tempConvertedAmount === "0") {
            tempConvertedAmount = (amount / res?.target_lowest_rate).toFixed(8);
          }
          setConvertedAmount(
            showBtcAmount && currency === sats
              ? BTCToFiatAmount(amount, res?.target_lowest_rate)
              : tempConvertedAmount
          );
        }
      })
      .catch((err) => {
        console.log("Error while calling exchange rate api:", err);
      });

    getSpeedFee();
  }, [currency]);
}

export default useExchangeAndSpeedFeeHook;
